import { Info } from 'components/common/form/modules/Info';
import { NumberInput } from 'components/common/form/modules/input/Number';
import { closeModal } from 'components/modal/modules/dispatcher/methods';
import React, { useCallback, useState } from 'react'
import { connect } from 'react-redux';
import UserDucks from 'stores/ducks/User.duck';
import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { updateSharedInventorybyAffiliate } from 'components/graphql/queries'
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';

const ValueLabelComponent = (props) => {
    const { children, open, value } = props;
    return (
        <Tooltip open={open} enterTouchDelay={0} placement="right" title={value}>
            {children}
        </Tooltip>
    );
}

ValueLabelComponent.propTypes = {
    children: PropTypes.element.isRequired,
    open: PropTypes.bool.isRequired,
    value: PropTypes.number.isRequired,
};

const AffiliatesModal: React.FC<{ [label: string]: any }> = (props: any) => {
    const [sharedInventory, setSharedInventory] = useState(props.sharedInventory)
    const [btnDisabled, setBtnDisabled] = React.useState(false)
    const [updateBtnText, setUpateBtnText] = React.useState('UPDATE')

    const resetUpdateBtn = () => {
        setBtnDisabled(false)
        setUpateBtnText('UPDATE')
    }

    const updateCommission = useCallback(() => {
        let qtyErr = false
        let comErr = false

        sharedInventory.map((item: any, index: number) => {

            if (Number(item.quantity) < Number(item.minQuantity) || Number(item.quantity) > Number(item.maxQuantity)) {
                qtyErr = true
            }

            if (Number(item.commission) < Number(props.sharedInventory[index].commission) || Number(item.commission) > Number(item.maxCommission)) {
                comErr = true
            }

        })

        setBtnDisabled(true)
        setUpateBtnText('UPDATING...')

        if (qtyErr) {
            resetUpdateBtn()
            return alert('Quantity is invalid for one or more items')
        }

        if (comErr) {
            resetUpdateBtn()
            return alert('Commission is invalid for one or more items')
        }

        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: updateSharedInventorybyAffiliate,
                variables: {
                    campaignId: props.campaignId,
                    userId: props.user.isAdmin ? props.createdBy : props.user.id,
                    username: props.username,
                    inventoryItems: sharedInventory.map((i: any) => {
                        console.log('i.sell')
                        console.log(i.sell)
                        return {
                            inventoryItemId: i.inventoryItemId,
                            quantity: Number(i.quantity),
                            commission: Number(i.commission) * 100,
                            commissionRate: i.commissionRate ? Number(i.commissionRate) : null,
                            sell: i.sell === undefined ? true : i.sell
                        }
                    })
                }
            })
            .then(res => {
                if (res.data.data.inventoryItem.updateSharedInventorybyAffiliate) {
                    props.reloadData()
                    closeModal()
                } else {
                    alert('An unknown error occurred, try again')
                    resetUpdateBtn()
                }
            })
            .catch(err => {
                console.log(err)
                alert('An unknown error occurred, try again')
                resetUpdateBtn()
            })
        closeModal()
    }, [sharedInventory, props.sharedInventory, props.username, props.campaignId])

    const handleInventoryChange = useCallback((index, type, value) => {

        if (Number.isNaN(Number(value))) {
            return;
        }

        const temp = JSON.parse(JSON.stringify(sharedInventory))

        if (type === 'quantity') {
            temp[index].quantity = Number(value)
        } else if (type === 'commission') {
            temp[index].commissionRate = null
            temp[index].commission = Number(value)
        } else if (type === 'commission rate') {
            temp[index].commissionRate = Number(value)
            temp[index].commission = Number(temp[index].maxCommission * temp[index].commissionRate / 100)
        } else if (type === 'sell') {
            temp[index].sell = !temp[index].sell
        }

        setSharedInventory(temp)
    }, [sharedInventory, setSharedInventory])

    return <div>
        <div style={{ overflowX: "scroll", paddingTop: '10px' }}>
            {
                sharedInventory.length > 0 ?
                    <table className='table-responsive--base m-0' style={{ width: '100%', textAlign: 'left', fontSize: '12px', paddingTop: '0px', marginTop: '5px' }}>
                        <thead>
                            <tr>
                                <td>TICKET</td>
                                <td>QTY</td>
                                {
                                    props.username.includes("-additional-link-") ? null : <td>COMMISSION</td>
                                }
                                <td>SALES</td>
                                <td>HIDE</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                sharedInventory.map((item: any, index: any) => {
                                    if (!item || !props.sharedInventory[index]) {
                                        return null
                                    }
                                    return <tr key={index} style={{ alignContent: 'center', height: 'auto', padding: '10px' }}>
                                        <td>
                                            {item.inventoryItemName}
                                        </td>
                                        <td>
                                            <NumberInput
                                                value={item.quantity}
                                                min={item.minQuantity}
                                                max={item.maxQuantity}
                                                onChange={(e) => handleInventoryChange(index, 'quantity', e.target.value)}
                                                infoMessage={item.minQuantity + ' - ' + item.maxQuantity}
                                            />
                                        </td>
                                        {
                                            props.username.includes("-additional-link-") ? null : <td>
                                                <span style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginBottom: '5px', marginTop: '7px' }}>
                                                    <button
                                                        onClick={() => {
                                                            const temp = JSON.parse(JSON.stringify(sharedInventory))
                                                            temp[index].commissionRate = null
                                                            setSharedInventory(temp)
                                                        }}
                                                        style={{
                                                            paddingTop: '6px',
                                                            width: '25px',
                                                            height: '25px',
                                                            marginLeft: '10px',
                                                            borderRadius: '50%',
                                                            backgroundColor: item.commissionRate === null || item.commissionRate === undefined ? '#242d51' : 'white',
                                                            color: item.commissionRate === null || item.commissionRate === undefined ? 'white' : 'black'
                                                        }}
                                                    >$</button>
                                                    <button
                                                        onClick={() => {
                                                            const temp = JSON.parse(JSON.stringify(sharedInventory))
                                                            temp[index].commissionRate = Number(item.commission / item.maxCommission * 100)
                                                            setSharedInventory(temp)
                                                        }}
                                                        style={{
                                                            paddingTop: '6px',
                                                            width: '25px',
                                                            height: '25px',
                                                            marginLeft: '5px',
                                                            borderRadius: '50%',
                                                            backgroundColor: item.commissionRate === null || item.commissionRate === undefined ? 'white' : '#242d51',
                                                            color: item.commissionRate === null || item.commissionRate === undefined ? 'black' : 'white'
                                                        }}
                                                    >%</button>
                                                </span>
                                                {
                                                    props.username.includes("-additional-link-")
                                                        ? null
                                                        : item.commissionRate === null || item.commissionRate === undefined
                                                            ? <NumberInput
                                                                value={item.commission}
                                                                min={props.sharedInventory[index].commission}
                                                                max={item.maxCommission}
                                                                onChange={e => handleInventoryChange(index, 'commission', e.target.value)}
                                                                required={true}
                                                            />
                                                            : <NumberInput
                                                                value={item.commissionRate}
                                                                min={props.sharedInventory[index].commission / props.sharedInventory[index].inventoryItemPrice * 100}
                                                                max={100}
                                                                onChange={e => handleInventoryChange(index, 'commission rate', e.target.value)}
                                                                required={true}
                                                            />
                                                }
                                                <Info>
                                                    Affiliate earns  ${item.commission.toFixed(2)} <br />
                                                    You earn  ${
                                                        props.createdBy === props.user.id || props.user.isAdmin ?
                                                            (item.inventoryItemPrice - item.commission).toFixed(2)
                                                            : (item.maxCommission - item.commission).toFixed(2)
                                                    }<br />
                                                    (Minimum. ${props.sharedInventory[index].commission})
                                                </Info>
                                            </td>
                                        }
                                        <td>
                                            {item.minQuantity}
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={!item.sell}
                                                onChange={e => handleInventoryChange(index, 'sell', e.target.checked)}
                                                style={{ height: '10px', width: '10px' }}
                                            />
                                        </td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </table>
                    :
                    <p style={{ width: '100%', textAlign: 'center' }}>
                        Inventory item not shared with affiliates
                    </p>
            }
        </div>
        {
            sharedInventory.length > 0 ?
                <div style={{ width: '100%', textAlign: 'center', paddingTop: '20px' }}>
                    <button
                        disabled={btnDisabled}
                        role="submit"
                        type="submit"
                        className="new-button-save"
                        onClick={e => updateCommission()}
                    >
                        {updateBtnText}
                    </button>
                </div> : null
        }
    </div>
}

const mapStateToProps = state => ({
    user: UserDucks.getUser(state),
});

export default connect(mapStateToProps)(AffiliatesModal);


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsDashboard/AffiliatesModal.tsx